import React, { useEffect } from "react";
import Features from "./Features";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Layout from "../layout/Layout";
import FeaturesDescription from "./FeaturesDescription";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const FeaturesPage = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("funktion");
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const user = useSelector((state) => state.auth.user);

  const functionsBanner = `${blobURL}/function_side_image.jpg`;
  let language = localStorage.getItem("i18nextLng");

  return (
    <>
      {user ? (
        <Layout className="my-customers-table" showSidebar bgcolor>
          <Helmet>
            {schemaMarkup && (
              <script type="application/ld+json">
                {JSON.stringify(schemaMarkup)}
              </script>
            )}
            {language === LOCALES.EN_US ? (
              <link rel="canonical" href="https://invozio.com/function" />
            ) : (
              <link rel="canonical" href="https://invozio.com/funktion" />
            )}
          </Helmet>

          <div className="wrap_redire">
            <section className="banner redirect new_margin_header">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="left-content pb-0">
                      <h1 className="first">{t("FUNCTIONS")}</h1>

                      <h3 className="fnt_hedr fnt_family">
                        {t("OF THE BILLING TOOL")}
                        <br /> {t("FEATURES & BENEFITS")}
                      </h3>
                      <p>
                        {t(
                          "Invoicing without a company should be simple and smooth. At Invozio, we have made the process as intuitive and user-friendly as possible. Here's an overview of how invoicing with us works:"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="right-content feature_image">
                      <img
                        src={functionsBanner}
                        alt="functions-banner"
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Features />
            <FeaturesDescription t={t} />
          </div>
        </Layout>
      ) : (
        <Layout
          className="my-customers-table"
          dashboardFooter={dashboardFooter}
        >
          <Helmet>
          {schemaMarkup && (
            <script type="application/ld+json">
              {JSON.stringify(schemaMarkup)}
            </script>
          )}
            {language === LOCALES.EN_US ? (
              <link rel="canonical" href="https://invozio.com/function" />
            ) : (
              <link rel="canonical" href="https://invozio.com/funktion" />
            )}
          </Helmet>

          <div className="wrap_redire">
            <section className="banner redirect new_margin_header">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="left-content pb-0">
                      <h1 className="first">{t("FUNCTIONS")}</h1>

                      <h3 className="fnt_hedr fnt_family">
                        {t("OF THE BILLING TOOL")}
                        <br /> {t("FEATURES & BENEFITS")}
                      </h3>
                      <p>
                        {t(
                          "Invoicing without a company should be simple and smooth. At Invozio, we have made the process as intuitive and user-friendly as possible. Here's an overview of how invoicing with us works:"
                        )}
                      </p>
                      {!user && (
                        <Button
                          className="mt-3 new_theme_btn "
                          onClick={() =>
                            navigate(
                              language === LOCALES.EN_US
                                ? `/emailregister?lang=${LOCALES.EN_US}`
                                : `/e-postregister?lang=${LOCALES.SV_SE}`
                            )
                          }
                        >
                          {t("Create Free Account")}
                        </Button>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="right-content feature_image">
                      <img
                        src={functionsBanner}
                        alt="functions-banner"
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Features />
            <FeaturesDescription t={t} />
          </div>
        </Layout>
      )}
    </>
  );
};

export default FeaturesPage;
